import { ContentEntityContent, ImageAsset } from '@shapeable/ui';
import React from 'react';
import { classNames } from '@shapeable/utils';
import styled, { css } from 'styled-components'; 
const cls = classNames('image-value-intro');
import { Classable, HasChildren, ImageEntity, ContentEntity } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { MetricValue } from '../elements/metric-value';

// -------- Types -------->

export type ImageValueIntroProps = Classable & HasChildren & { 
  value?: number;
  entity?: ContentEntity & { image?: ImageEntity };
};

export const ImageValueIntroDefaultProps: Partial<ImageValueIntroProps> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
});

const BodyStyles = breakpoints({
  base: css`
    
  `,
});

const ValueStyles = breakpoints({
  base: css`
    margin-bottom: ${theme.UNIT(3)};
  `,
});

const ContentStyles = breakpoints({
  base: css`
    font-size: 1em;
    flex-shrink: 0;
  `,
});

const ImageStyles = breakpoints({
  base: css`
    width: 40% !important;
    margin-right: ${theme.UNIT(4)};
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
  Layout: styled.div`${LayoutStyles}`,
    Body: styled.div`${BodyStyles}`,
    Value: styled(MetricValue)`${ValueStyles}`,
    Content: styled(ContentEntityContent)`${ContentStyles}`,
  Image: styled(ImageAsset)`${ImageStyles}`,
};

export const ImageValueIntro: React.FC<ImageValueIntroProps> = (props) => {
  const { className, children, value, entity } = props;

  const { image, content } = entity || {};

  const hasContent = !!content;

  return (
    <My.Container className={cls.name(className)}>
      <My.Layout>
        {
          image && <My.Image entity={image} />
        }
        <My.Body>
          {
            <My.Value value={value} />
          }
          {
            hasContent && <My.Content entity={entity} />
          }
        </My.Body>
      </My.Layout>
      {children}
    </My.Container>
  )
};

ImageValueIntro.defaultProps = ImageValueIntroDefaultProps;
